import { useRef } from "react";
import { ArrowLeft2, ArrowRight2 } from "iconsax-reactjs";
import StoryCarouselItem from "./StoryCarouselItem";
import StoryCarouselItemSkeleton from "./StoryCarouselItemSkeleton";
import Button from "../../commons/Button";
import type { Story } from "../../../services/webServices/srory/types";

type StoryCarouselProps = {
  story: Story[];
  isLoading: boolean;
  onEdit: (uuid: string) => void;
  onDelete: (uuid: string) => void;
};

export default function StoryCarousel({ story, onEdit, isLoading, onDelete }: StoryCarouselProps) {

  const scrollRef = useRef<HTMLDivElement | null>(null);

  const scroll = (dir: "left" | "right") => {
    const amount = dir === "left" ? -300 : 300
    scrollRef.current?.scrollBy({ left: amount, behavior: "smooth" })
  }

  return (
    <div className="relative">
      <Button
        variant="primary"
        style="outline"
        size="md"
        text=""
        loading={false}
        disabled={false}
        onClick={() => scroll("left")}
        icon={ArrowLeft2}
        customClassName="group absolute left-4 top-1/2 -translate-y-1/2 z-10"
      />

      <Button
        variant="primary"
        style="outline"
        size="md"
        text=""
        loading={false}
        disabled={false}
        onClick={() => scroll("right")}
        icon={ArrowRight2}
        customClassName="group absolute right-4 top-1/2 -translate-y-1/2 z-10"
      />
      <div
        ref={scrollRef}
        className="max-w-full min-h-[211px] bg-white border rounded-2xl card-shadow px-14 py-6 flex flex-row flex-nowrap gap-6 overflow-x-auto overflow-y-hidden no-scrollbar"
      >
        {isLoading
          ? Array.from({ length: 12 }).map((_, i) => (
              <StoryCarouselItemSkeleton key={i} />
            ))
          : story.map(item => (
              <StoryCarouselItem
                key={item.uuid}
                uuid={item.uuid}
                coverSrc={item.cover_image}
                label={item.label}
                title={item.title}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))
        }
      </div>
    </div>
  );
};